<template>
  <div class="container">
    <!-- 左侧 -->
    <sz-mode szType="grid" :bg="'left_bg'" position="left-top" width="23.5%" height="28%" lineShow="true">
      <template #grid>
        <div class="panel_item">
          <div class="panel_title">党建总览</div>
          <div v-if="slideList.length > 0">
            <swiper :options="swiperOptions">
              <swiper-slide v-for="(item, index) in slideList" :key="index">
                <img :src="baseURL + item.historyImg" alt="" />
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
        </div>
      </template>
    </sz-mode>

    <sz-mode szType="grid" :bg="'left_bg'" position="left-top" width="23.5%" height="28%" top="31%" lineShow="true">
        <template #grid>
          <div class="panel_item">
            <div class="panel_title">党委班子</div>
            <div class="flex_start flex_center_align cun_cheng">
              <div>党组织架构</div>
              <img class="jinru" src="@/assets/img/jinru.png"  @click="showMode('党委班子','partyorganize')" />
            </div>
            <div style="padding: 10px 0;font-size: 18px;">
              <p style="text-indent: 15px;">小平房村党支部在上级党委的正确领导下，全面贯彻落实大精神，解放思想、实事求是，以创建“五好”党支部为目标，紧紧围绕全党工作大局和市、镇中心工作，认真贯彻执行市委关于争创党建先进市的一系列部署，从思想上、组织上、作风上全面加强党的建设，用改革的精袖努力开拓党建工作的新局面，扎实地把党支部建设成为带领全村干部、群众发家致富的战斗堡垒，充分发挥党员的先锋模范作用，保证了村党支部各项工作的顺利进行。</p>
           </div>
          </div>
        </template>
      </sz-mode>
    <sz-mode szType="grid" :bg="'left_bg'" position="left-bottom" width="23.5%" height="38%" lineShow="true">
      <template #grid>
        <div class="panel_item">
          <div class="panel_title">党建专栏</div>
          <div class="his_list">
            <div class="his_list_item" v-for="(item, index) in djHis" @click.stop="seeHis(index)">
              <div class="list_item_title">{{ item.historyName }}</div>
              <div class="list_item_date">{{ item.historyDate }}</div>
            </div>
          </div>
        </div>
      </template>
    </sz-mode>
    <!-- 右侧 -->
    <sz-mode szType="grid" :bg="'left_bg'" position="right-top" width="23.5%" height="28%" lineShow="true">
      <template #grid>
        <div class="panel_item">
          <div class="panel_title flex_start flex_center_align" style="justify-content: space-between!important;">
            <div>党员基本情况</div>
            <img class="jinru" style="width: 22px;height: 24px;" src="@/assets/img/jinru.png"  @click="showMode('党员基本情况','partybase')" />
          </div>
          <!-- member总人数 -->
          <div class="flex_center_align flex_item">
            <div class="flex_colum flex_item_col">
              <span class="flex_item_num">{{ totalNums.formalMember }}人</span>
              <span>正式党员</span>
            </div>
            <div class="flex_colum flex_item_col">
              <span class="flex_item_num">{{ totalNums.prepareMember }}人</span>
              <span>预备党员</span>
            </div>
            <div class="flex_colum flex_item_col">
              <span class="flex_item_num">{{ totalNums.developMember }}人</span>
              <span>50周年党员</span>
            </div>
          </div>
          <div class="flex_center_align flex_item">
            <div class="flex_colum flex_item_col">
              <span class="flex_item_num">{{ totalNums.flowMember }}人</span>
              <span>流动党员</span>
            </div>
            <div class="flex_colum flex_item_col">
              <span class="flex_item_num">{{ totalNums.bedMember }}人</span>
              <span>优秀党员</span>
            </div>
            <div class="flex_colum flex_item_col">
              <span class="flex_item_num">{{ totalNums.armyMember }}人</span>
              <span>军队退役党员</span>
            </div>
          </div>
        </div>
      </template>
    </sz-mode>
    <sz-mode szType="grid" :bg="'left_bg'" position="right-top" top="31%" width="23.5%" height="28%" lineShow="true">
      <template #grid>
        <div class="panel_item">
          <div class="panel_title">党建活动</div>
          <!-- member总人数 -->
          <div class="his_list">
            <div class="his_list_item" v-for="(item, index) in djActive" @click.stop="seeHis(index, 'active')">
              <div class="list_item_title">{{ item.articleTitle }}</div>
              <div class="list_item_date">{{ item.createTime }}</div>
            </div>
          </div>
        </div>
      </template>
    </sz-mode>

    <sz-mode szType="grid" :bg="'left_bg'" position="right-bottom" width="23.5%" height="38%" lineShow="true">
      <template #grid>
        <div class="panel_item">
          <div class="panel_title">党员基本情况</div>
          <div class="flex_center_align flex_space">
            <div class="chart_item">
              <div class="chart_title">学历结构</div>
              <div id="xlChart" ref="xlChart" style="width:100%;height:150px;margin-top:20px"></div>
            </div>
          </div>
          <div class="flex_center_align flex_space">
            <div class="chart_item">
              <div class="chart_title">党龄结构</div>
              <div id="dlChart" ref="dlChart" style="width:100%;height:150px;margin-top:20px"></div>
            </div>
          </div>
        </div>
      </template>
    </sz-mode>

    <!-- 党建专栏详情 -->
    <wg-mode ref="wgMode"></wg-mode>
    <cun-mode ref="cunMode"></cun-mode>
    <!-- 地图 -->
    <div id="mapcontainer" class="divwxMap" style="width: 100%; height:100%"></div>

    <num-mode ref="numMode"></num-mode>
    <t-footer></t-footer>
  </div>
</template>
<script>
import * as echarts from 'echarts'
import WgMode from '@/components/wgMode.vue'
import { pieoption, poption } from '@/utils/options'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { getHisItems, getDangIndex, getDangArea, getDangNews } from '@/api/api.js'
import 'swiper/css/swiper.min.css'
import CunMode from '@/components/cunMode.vue'
import NumMode from '@/components/numMode.vue'

export default {
  components: {
    WgMode,
    swiper,
    swiperSlide,
    CunMode,
    NumMode
  },
  data() {
    return {
      baseURL: process.env.VUE_APP_API,
      baseForm: {},
      totalNums: {},
      djHis: [{ historyName: 'dangjian党建' }],
      swiperOptions: {
        autoplay: false,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets'
        }
      },
      // slideList: [{ img: 'https://img1.baidu.com/it/u=4049022245,514596079&fm=253&app=120&size=w931&n=0&f=JPEG&fmt=auto?sec=1681318800&t=2b375ed6d93d638d1be405d04eb8c7f2' }]
      slideList: [],
      djActive: [],
    }
  },
  mounted() {
    this.baseForm = JSON.parse(sessionStorage.getItem('userInfo'))
    this.$nextTick(() => {
      this.initMap()
      // 查询党建专栏列表
      this.getItems()
      this.searchDetails()
      this.getAreas()
      // this.getNews(1)
      this.getNews(5)
    })
  },
  methods: {
    getAreas() {
      getDangArea({ villageId: this.baseForm.regionId }).then(res => {
        if (res.code == '0') {
          if (res.model.length > 0) {
            res.model.map(i => {
              i.articleContent = i.branchText
              i.name = i.branchName
              i.type = 'party'
            })
          }
          this.setCunMap(res.model)
        }
      })
    },
    searchDetails() {
      getDangIndex({ villageId: this.baseForm.regionId }).then(res => {
        if (res.code == 0) {
          this.totalNums = res.model.memberCount
          this.$nextTick(() => {
            this.drowFunction(res.model)
          })
        }
      })
    },
    //查询党建列表
    getItems() {
      getHisItems({ villageId: this.baseForm.regionId, historyType: 1, page: 1, rows: 10000 }).then(res => {
        if (res.code == '0') {
          if (res.items.length > 0) {
            let arr = []
            res.items.map(item => {
              if (item?.historyImg) arr.push(item)
              if (item.historyDate) item.historyDate = this.$moment(item.historyDate).format('YYYY-MM-DD')
            })
            this.slideList = arr
          }
          if (this.slideList.length > 1) {
            this.swiperOptions.autoplay = {
              delay: 3000,
              disableOnInteraction: true
            }
          }
          this.djHis = res.items
        }
      })
    },
    //初始化地图
    initMap() {
      // vue项目需要先声明 T = window.T，不然后面无法获取到。
      let T = window.T
      this.wxMap = null
      let initMap = new T.Map('mapcontainer') // div的id
      // 传参中心点经纬度，以及放大程度，最小1，最大18
      initMap.centerAndZoom(new T.LngLat(Number(this.baseForm.longitude), Number(this.baseForm.latitude)), 12.5)

      initMap.setStyle('black')
      initMap.enableDrag()
      initMap.isScrollWheelZoom(true)
      initMap.enableScrollWheelZoom(true)

      let center_lng = 0
      let center_lat = 0

      initMap.addEventListener('mousemove', function(e) {
        center_lng = e.lnglat.lng
        center_lat = e.lnglat.lat
      })
      // let center_lng = 0
      // let center_lat = 0
      // // // 监听地图缩放开始事件 lng表示经度，lat表示纬度
      initMap.addEventListener('zoomstart', function(e) {
        // center_lng = initMap.getCenter().lng
        // center_lat = initMap.getCenter().lat
        console.log(e)
      })
      // 监听地图缩放结束事件 lng表示经度，lat表示纬度
      initMap.addEventListener('zoomend', function(e) {
        initMap.centerAndZoom(new T.LngLat(center_lng, center_lat), initMap.getZoom())
      })

      this.wxMap = initMap

      this.initBorder()
    },
    addMapMousemove() {
      console.log('1111')

      removeMapMousemove()
      this.initMap.addEventListener('mousemove', MapMousemove)
    },

    removeMapMousemove() {
      this.initMap.removeEventListener('mousemove', MapMousemove)
    },

    MapMousemove(e) {
      document.getElementById('info').value = e.lnglat.getLng().toFixed(6) + ',' + e.lnglat.getLat().toFixed(6)
    },
    //在地图标点
    setCunMap(data) {
      this.setMapSetting(data)
      this.setRegion(data)
    },
    //查看党建信息详情
    seeHis(index, type) {
      if (type == 'active') {
        let data = this.djActive[index]
        data.itemtype = 'historyArtic'
        this.$refs.wgMode.initData(data)
      } else {
        let data = this.djHis[index]
        data.itemtype = 'history'
        this.$refs.wgMode.initData(data)
      }
    },

    drowFunction(data) {
      pieoption.tooltip = {
        show: true,
        formatter: '{b}: {c}人'
      }
      pieoption.series[0].label = { show: false }
      pieoption.series[0].emphasis = { show: true }

      pieoption.legend = {
        itemHeight: 10,
        itemWidth: 12,
        orient: '',
        show: true,
        top: '5%',
        right: '10%',
        textStyle: { color: '#fff' }
      }
      if (data?.background) {
        pieoption.series[0].radius = ['45%', '75%']
        pieoption.series[0].center = ['40%', '50%']
        pieoption.series[0].data = data.background

        var piedom = echarts.init(this.$refs.xlChart, null, { renderer: 'svg' })
        piedom.clear()
        piedom.setOption(pieoption)
      }
      this.$nextTick(() => {
        if (data.branchAge.length > 0) {
          pieoption.series[0].radius = ['0', '75%']
          pieoption.series[0].center = ['40%', '50%']
          pieoption.series[0].data = data.branchAge
          var piedom1 = echarts.init(this.$refs.dlChart, null, { renderer: 'svg' })
          piedom1.clear()
          piedom1.setOption(pieoption)
        }
      })
      if (data.memberCount.man && data.memberCount.woMan) {
        poption.series[0].data = [{ value: data.memberCount.man, maxNum: data.memberCount.member }, { value: data.memberCount.woMan, maxNum: data.memberCount.member }]
        poption.series[1].data = [{ realValue: data.memberCount.man, value: data.memberCount.member }, { realValue: data.memberCount.woMan, value: data.memberCount.member }]
        console.log(poption.series)

        // poption.series[0].data = [data.memberCount.man, data.memberCount.woMan]
        var piedom2 = echarts.init(this.$refs.xbChart, null, { renderer: 'svg' })
        piedom2.clear()
        piedom2.setOption(poption)
      }
    },
    getNews(sub) {
      getDangNews({ articleType: 1, articleSubtype: sub }).then(res => {
        if (res.code == '0') {
          if (res.items.length > 0) {
            res.items.map(item => {
              if (item.createTime) item.createTime = this.$moment(item.createTime).format('YYYY-MM-DD')
            })
          }
          this.djActive = res.items
        }
      })
    },
    showMode(name, type) {
      let item = { type: type, name: name, showType: type, regionId: this.baseForm.regionId }
      this.$refs.numMode.initData(item)
    }
  }
}
</script>
<style lang="scss" scope>
.container {
  z-index: 9;
  /deep/ .tdt-label {
    -webkit-box-shadow: none;
    box-shadow: none;
    border-radius: 8px;
    background-color: #515459e8 !important;
    border-color: rgb(116, 118, 121) !important;
  }
}
.container {
  .divwxMap {
    z-index: 0;
  }
  .c_left {
    position: fixed;
    left: 40px;
    width: 23.5%;
  }
  .c_right {
    position: fixed;
    right: 40px;
    width: 23.5%;
  }
  .panel_item {
    margin: 5px 12px;
    .panel_title {
      font-family: 'Microsoft YaHei';
      font-style: normal;
      font-weight: 400;
      font-size: 26px;
      text-shadow: 3px 1px 4px #3c8ccf;
      font-style: italic;
      letter-spacing: 5px;
    }
    .chart_item {
      flex: 1;
    }
    .chart_title {
      margin: 10px;
    }
    .center_title {
      text-align: center;
    }
  }
  .flex_item {
    width: 100%;
    justify-content: space-evenly;
    text-align: center;
    flex-wrap: wrap;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #fff;
    .flex_item_col {
      width: 30%;
      margin: 10px 0;
      flex: 1;
      color: #fff;
    }
    .flex_item_num {
      font-family: 'Microsoft YaHei';
      font-style: normal;
      font-weight: 400;
      font-size: 26px;
      // cursor: pointer;
    }
  }
  .member {
    height: 105px;
    overflow-y: auto;
  }
  .member_mes {
    width: 100%;
    justify-content: space-evenly !important;
    margin: 2px 0;
    cursor: pointer;
  }
  /*网格员姓名 */
  .grid_member .member_mes .member_full_name {
    font-family: 'Source Han Sans CN';
    font-weight: 400;
    font-size: 18px;
    line-height: 27px;
    /* color: #FFFFFF; */
  }

  /*网格员电话 */
  .grid_member .member_mes .member_mobile {
    font-family: 'Source Han Sans CN';
    font-weight: 400;
    font-size: 18px;
    line-height: 27px;
    /* color: #FFFFFF; */
  }
  .his_list_item {
    padding: 10px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.4);
    cursor: pointer;
  }
  .list_item_title {
    width: 100%;
    font-size: 18px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
  .list_item_date {
    font-size: 16px;
    text-align: right;
    color: #ccc;
  }
  .swiper-container {
    width: 400px;
    height: 190px;
    .swiper-slide {
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.cun_cheng {
  padding-top: 10px;
  font-size: 20px;
  justify-content: space-between !important;
}
</style>
